module.exports = __webpack_public_path__ + "static/madebymany-white-7e939fdfe8d96535f2b20248b8719e57.svg";